<template>
  <select class="common-select" :value="value" @change="onChange">
    <option :value="null">{{ placeholder }}</option>
    <option
        v-for="item in items"
        :key="item[keyField]"
        :value="item[valueField]"
    >
      {{ item[labelField] }}
    </option>
  </select>
</template>

<script>
export default {
  name: "CommonSelect",
  props: {
    value: { required: false },
    items: { type: Array, required: true },
    keyField: { type: String, default: "id" },
    valueField: { type: String, default: "id" },
    labelField: { type: String, default: "name" },
    placeholder: { type: String, default: "" }
  },
  methods: {
    onChange(e) {
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
    }
  }
};
</script>
<style lang="scss">
.common-select {
  height: 32px;
  font-size: 14px;
  border-radius: 4px;
  padding: 0 8px;
  border-color: #c1c1c1;
  color: #4c4c4c;
}
</style>
